import scrollLock from '@mockly/scroll-lock';

const selectors = {
  trigger: '[data-cart-drawer-trigger]',
  content: '[data-cart-drawer-content]',
  close: '[data-cart-drawer-close]',
}

class ComponentCartDrawer extends HTMLElement {
  isOpen = false;
  isMobile = false;

  constructor() {
    super();

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.content = this.querySelector(selectors.content);
    this.triggers = Array.from(this.querySelectorAll(selectors.trigger));
    this.close = this.querySelector(selectors.close);
    this.interactiveElements = Array.from(this.content.querySelectorAll('a'));

    if (!this.triggers?.length || !this.content) return;

    this.handleResize();

    setTimeout(() => {
      this.setupEventListeners();
    }, 10);
  }

  handleResize() {
    this.isMobile = window.innerWidth < 800;
  }

  handleOutsideClick(e) {
    if (!this.content.contains(e.target) && !this.triggers.includes(e.target) && !this.triggers.some(trigger => trigger.contains(e.target))) {
      this.closeDrawer();
    }
  }

  handleKeyDown(e) {
    if ((e.key === 'Escape' || e.key === 'Home') && this.isOpen) {
      this.closeDrawer();

      requestAnimationFrame(() => {
        this.triggers?.forEach(trigger => trigger.blur());
      });
    }
  }

  setupEventListeners() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('click', this.handleOutsideClick);
    
    this.triggers?.forEach(trigger => trigger.addEventListener('click', this.toggleDrawer));
    this.close?.addEventListener('click', this.closeDrawer);
    
    this.interactiveElements?.forEach(element => {
      element.addEventListener('click', this.closeDrawer);
    });
  }

  removeEventListeners() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleKeyDown);
    
    this.triggers?.forEach(trigger => trigger.removeEventListener('click', this.toggleDrawer));
    this.close?.removeEventListener('click', this.closeDrawer);
    
    this.interactiveElements?.forEach(element => {
      element.removeEventListener('click', this.closeDrawer);
    });
  }

  toggleDrawer(e) {
    if (this.isOpen || e.currentTarget.tagName === 'A') {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }
  
  openDrawer() {
    this.isOpen = true;
    this.content.setAttribute('data-open', this.isOpen);
    this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', this.isOpen));
    this.content.removeAttribute('inert');

    if (this.isMobile) {
      scrollLock.lock();
    }
  }

  closeDrawer() {
    this.isOpen = false;
    this.content.setAttribute('data-open', this.isOpen);
    this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', this.isOpen));
    this.content.setAttribute('inert', true);

    scrollLock.unlock();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', ComponentCartDrawer);
}